import { useTranslation } from "react-i18next";

const features = [
  {
    icon: "ri-radar-line",
    gradient: "from-emerald-500 to-teal-500",
    bg: "bg-emerald-50",
    titleKey: "home_feature1_title",
    descKey: "home_feature1_desc",
  },
  {
    icon: "ri-global-line",
    gradient: "from-sky-500 to-cyan-500",
    bg: "bg-sky-50",
    titleKey: "home_feature2_title",
    descKey: "home_feature2_desc",
  },
  {
    icon: "ri-notification-3-line",
    gradient: "from-amber-500 to-orange-500",
    bg: "bg-amber-50",
    titleKey: "home_feature3_title",
    descKey: "home_feature3_desc",
  },
];

const stats = [
  { value: "2.4M+", key: "home_stats_parcels", icon: "ri-box-3-line" },
  { value: "200+", key: "home_stats_countries", icon: "ri-earth-line" },
  { value: "98.7%", key: "home_stats_satisfaction", icon: "ri-star-line" },
];

export default function FeaturesSection() {
  const { t } = useTranslation();

  return (
    <section className="py-24 relative overflow-hidden" style={{ background: "linear-gradient(160deg, #f0fdf4 0%, #f8fafc 40%, #ecfdf5 100%)" }}>
      {/* Decorative blobs */}
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full opacity-20 pointer-events-none" style={{ background: "radial-gradient(circle, #6ee7b7 0%, transparent 70%)", transform: "translate(30%, -30%)" }} />
      <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full opacity-15 pointer-events-none" style={{ background: "radial-gradient(circle, #34d399 0%, transparent 70%)", transform: "translate(-30%, 30%)" }} />

      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        {/* Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-24">
          {stats.map((stat) => (
            <div
              key={stat.key}
              className="relative text-center p-8 rounded-2xl bg-white border border-emerald-100 overflow-hidden group hover:border-emerald-300 transition-all duration-300"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-50/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative z-10">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-emerald-100 text-emerald-600 mx-auto mb-4">
                  <i className={`${stat.icon} text-xl`} />
                </div>
                <div className="text-3xl md:text-4xl font-bold text-slate-800 mb-1">{stat.value}</div>
                <div className="text-slate-500 text-sm">{t(stat.key)}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Features heading */}
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-semibold tracking-widest text-emerald-600 uppercase mb-3 bg-emerald-100 px-4 py-1.5 rounded-full">
            Why Choose Us
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-slate-800">
            {t("home_features_title")}
          </h2>
        </div>

        {/* Feature cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
          {features.map((f) => (
            <div
              key={f.titleKey}
              className="group relative p-7 rounded-2xl bg-white border border-gray-100 hover:border-transparent hover:shadow-lg transition-all duration-300 overflow-hidden"
            >
              {/* Hover gradient overlay */}
              <div className={`absolute inset-0 bg-gradient-to-br ${f.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-300`} />

              <div className={`relative z-10 w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br ${f.gradient} mb-5 shadow-sm`}>
                <i className={`${f.icon} text-2xl text-white`} />
              </div>
              <h3 className="relative z-10 font-semibold text-slate-800 text-base mb-2">{t(f.titleKey)}</h3>
              <p className="relative z-10 text-slate-500 text-sm leading-relaxed">{t(f.descKey)}</p>

              {/* Bottom accent line */}
              <div className={`absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r ${f.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-300`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
